import { useQuery } from '@tanstack/react-query'
import { apiClient } from '~/shared/api/data-ingestion-api'
import { retryUnlessClientError } from '~/shared/lib/api-error'
import { DOCUMENT_AGENT_QUERY_KEYS } from '../config'
import type { DocumentTextResponse } from '../model'

/** 404 when the document has no `.md` (documents from before 2026-08-25) or the API predates the endpoint. */
export function useDocumentText(documentKey: string) {
  return useQuery({
    queryKey: DOCUMENT_AGENT_QUERY_KEYS.text(documentKey),
    queryFn: async () => {
      const response = await apiClient.client.get({
        url: '/document-agent/documents/{key}/text',
        path: { key: documentKey },
        throwOnError: true,
      })
      return response.data as DocumentTextResponse
    },
    staleTime: Infinity,
    retry: retryUnlessClientError,
  })
}
